import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import qs from 'qs';
import axios from 'axios';

const ColoredLine = ({ color }) => (
  <hr
      style={{
          color: color,
          backgroundColor: color,
          height: 1.5,
          width: '40%'
      }}
  />
);

export class ShowQrCode extends Component {
  constructor (props){
    super(props);
    this.state = {
      qrLoaded:false,
      qrCodeBase64:""
    };
  }

  componentDidMount() {
    var self = this;
    var query = {
      qrCodeData:self.props.user.accountRs,
      width:240,
      height:240
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    const url_encodeQRCode = self.props.nodeurl+'?requestType=encodeQRCode';
    axios.post(url_encodeQRCode, qs.stringify(query), config).then(function(response) {
      console.log('Got it: Account QRCode');
      self.setState({qrLoaded:true,qrCodeBase64:response.data.qrCodeBase64})
    });
  }


  
  render(){
    const qrdataurl = "data:image/png;base64,"+this.state.qrCodeBase64;
    return(
      <div style={{textAlign:"center", width:"90%", display:"inline",   justifyContent:'center', alignItems:'center'}} >
      <Grid container
        justify="center"
        direction="column"
        spacing={24}
        style={{padding:20}}
      >
        <Grid item>
          <Typography variant="h6">
            Your Address 
            <ColoredLine color="white" />
          </Typography>
          <Typography variant="h5" translate="no">
            {this.props.user.accountRs}
                      </Typography>

          <Typography>&nbsp;</Typography>
          <Typography color="error" variant="button">IMPORTANT: Please only send IGNIS, GEM, GIFTZ or Mythical Being Cards to this address.</Typography>
        </Grid>
        <Grid item><img alt="your ARDOR address" src={qrdataurl}/></Grid>
        
      </Grid>
      </div>
    );
  }
}